import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaHandsHelping } from 'react-icons/fa'
import { GoArrowUpRight } from 'react-icons/go'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { updateModal } from '../../store/slices/modalSlice'

function Hero() {
    const dispatch = useDispatch();
    return (
        <div className='hero-home py-2'>
            <Container>
                <Row className='gy-4'>
                    <Col className='col-12 col-lg-6 ps-lg-0 d-grid align-content-center gap-4 hero-content pt-4 pt-lg-0'>
                        <h1 className='fs-48 fw-semibold m-0 fs-md-35 fs-sm-25 text-center text-lg-start' data-aos="fade-right" data-aos-delay="150">Eco-Friendly Paper Cups <br /> for Every Occasion</h1>
                        <p className='m-0 fs-18 fs-md-16 fs-sm-14 text-center text-lg-start' data-aos="fade-right" data-aos-delay="300">Durable designs that support the environment and elevate <br /> your brand.</p>
                        <div className='d-flex justify-content-center justify-content-lg-start' data-aos="fade-right" data-aos-delay="450">
                            <Link className='new-theme-contra-btn-first' onClick={() => dispatch(updateModal(true))}>
                                Get in Touch
                                <span><FaHandsHelping /></span>
                            </Link>
                        </div>
                    </Col>
                    <Col className='col-12 col-lg-6 pe-lg-5'>
                        <div className='hero-img-holder' data-aos="zoom-in" data-aos-delay="150">
                            <img src={require('../../assets/images/hero1.png')} alt="" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Hero